import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import fetchStoreListForProductListingService from "../../../../../Service/OPSServices/AmazonProductListing/fetchStoreListForProductListingService";
import { connect } from 'react-redux';
import ReactTable from "react-table";

function ProductListingStore(props) {

  const [selectedStore, setSelectedStore] = useState("");
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [searchText, setSearchText] = useState('');

  const handleStoreChange = (e) => {
    const storeId = e.target.value
    setSelectedStore(storeId)

    const store = props.storeList && props.storeList.find(s => s.id == storeId)
    setSelectedStoreDetails(store)
  }
  const filterProductData =selectedStoreDetails && (selectedStoreDetails.products || []).filter((row) => {
    const parentProduct = (row.parentProduct || '').toLowerCase();
    const isParentProduct = row.isParentProduct ? 'yes' : 'no';
    const productTitle = (row.productTitle || '').toString().toLowerCase();
    const asin = (row.asin || '').toString().toLowerCase();
    return (
      isParentProduct.includes(searchText.toLowerCase()) ||
      parentProduct.includes(searchText.toLowerCase())||
      asin.includes(searchText.toLowerCase())||
      productTitle.includes(searchText.toLowerCase())
    );
  });   
  const handleAsinClick = (product) => {
    props.nextStep({
      storeId: selectedStoreDetails.id,
      sellerId: selectedStoreDetails.stringID,
      marketplaceId: selectedStoreDetails.marketplaceStringId,
      currency: selectedStoreDetails.currencyCode,
      asin: product.asin,
      productTitle: product.productTitle,
      parentAsin: product.parentProduct,
    });
  };
  const columns = [
    
      {
        Header: "Parent Asin",
        accessor: "parentProduct",
        width: 110,
        Cell: (cellInfo) => (
          <div className="d-flex justify-content-center w-100">
            <p className='mb-0'>{cellInfo.value}</p>
          </div>
        ),
      },
      {
        Header: "Asin",
        accessor: "asin",
        width: 110,
        Cell: (cellInfo) => (
          <div className="d-flex justify-content-center w-100">
            <p
              className='mb-0 text-primary'
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => handleAsinClick(cellInfo.row._original)}
            >
              {cellInfo.value}
            </p>
          </div>
        ),
      },
    {
      Header: "Product Title",
      accessor: "productTitle",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <p title={cellInfo.value}className='mb-0'>{cellInfo.value}</p>
        </div>
      ),
    },
    ]

  return (
<>
    <Container>

      <Row>

        {/* Page Title */}

        <Col md={12} className="mt-2 mb-2">
          <h4>Step 1 : Store Selection</h4>
        </Col>


        {/* Store Selection Card */}

        <Col md={12} className="ml-1 mr-4">

          <Card className="p-4">

            <Row className="mb-3">

              <Col md={4} className="amazon-listing-labels">Store : </Col>

              <Col md={8}>

                <Input
                  type="select"
                  value={selectedStore}
                  onChange={handleStoreChange}
                >

                  <option value="">-- Select Store --</option>

                  {props.storeList && props.storeList.map((store) => (
                    <option key={store.id} value={store.id}>
                      {store.name}
                    </option>
                  ))}

                </Input>

              </Col>

            </Row>


            {/* Store Details */}

            {selectedStoreDetails && (
<>
              <Row className="mt-4 mb-2">

                <Col md={4}>
                  <p className="mb-0"><b>Seller ID</b></p>
                  <p>{selectedStoreDetails.stringID}</p>
                </Col>

                <Col md={4}>
                  <p className="mb-0"><b>Marketplace ID</b></p>
                  <p>{selectedStoreDetails.marketplaceStringId}</p>
                </Col>

                <Col md={4}>
                  <p className="mb-0"><b>Currency</b></p>
                  <p>{selectedStoreDetails.currencyCode}</p>
                </Col>

              </Row>
              <Row>
              <Col md={12} className="d-flex justify-content-end">
                <Input
                  className="mb-2 w-50"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search product by Title and ASIN "
                />
              </Col>
            <Col md={12}>
            <ReactTable
                      data={filterProductData}
                      columns={columns}
                      className="-fixed -highlight -striped mt-2"
                      getTheadProps={() => ({
                        style: {
                          overflowY: "hidden",
                          background: "#B1FA63",
                          color: "#243837",
                        },
                      })}
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct) {
                          return {
                            style: {
                              backgroundColor: '#dfd7ff', 
                            },
                          };
                        }
                        return {};
                      }}
                      defaultPageSize={5}
                      noDataText={"No Data Found."}
                    />
            </Col>
          </Row> 
          </>
            )}

          </Card>

        </Col>


        {/* Next Button */}

        {/* <Col md={12} className="mt-3 d-flex justify-content-end">

          <button
            className="btn btn-primary"
            disabled={!selectedStore}
            onClick={() =>
              props.nextStep({
                storeId: selectedStoreDetails.id,
                sellerId: selectedStoreDetails.stringID,
                marketplaceId: selectedStoreDetails.marketplaceStringId,
                currency: selectedStoreDetails.currencyCode
              })
            }
          >
            Next →
          </button>

        </Col> */}

      </Row>

    </Container>
</>
  );
}
const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
  }
}

export default connect(mapStateToProps)(ProductListingStore);